import React from "react";
import { resolveAccentColor } from "./accentColors";

const VARIANT_PATHS = {
  triple: ["M8 12L15 19", "M22 5L23 16", "M36 11L30 19"],
  "mini-burst": ["M24 4L24 12", "M39 12L33 18", "M43 28L34 27", "M10 17L17 21"],
  "corner-rays": ["M13 5L13 18", "M18 23L29 14", "M22 29L38 29"],
  "curved-rays": ["M8 11C13 13 16 16 18 21", "M22 5C23 11 23 15 23 19", "M37 12C32 15 29 18 27 22"],
};

export default function AccentRays({
  variant = "triple",
  color = "mint",
  rotation = 0,
  className = "",
  style,
  ...props
}) {
  const paths = VARIANT_PATHS[variant] || VARIANT_PATHS.triple;
  const stroke = resolveAccentColor(color);

  return (
    <svg
      viewBox="0 0 48 48"
      className={`pointer-events-none ${className}`}
      aria-hidden="true"
      focusable="false"
      fill="none"
      style={{ transform: `rotate(${rotation}deg)`, transformOrigin: "center", ...style }}
      {...props}
    >
      {paths.map((d, index) => (
        <path
          key={`${variant}-${index}`}
          d={d}
          stroke={stroke}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
}
